import { render, staticRenderFns } from "./scanInput.vue?vue&type=template&id=a87964d0&scoped=true&"
import script from "./scanInput.vue?vue&type=script&lang=js&"
export * from "./scanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87964d0",
  null
  
)

export default component.exports